(function () {
  'use strict';

  const moneyFormat = window.Shopify && window.Shopify.moneyFormat ? window.Shopify.moneyFormat : '${{amount}}';

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* ---------------- Mobile nav ---------------- */
  const navToggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-site-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      const open = nav.getAttribute('data-open') === 'true';
      nav.setAttribute('data-open', String(!open));
      navToggle.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ---------------- Cart drawer ---------------- */
  const drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  }

  if (drawer) {
    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCart().then(openDrawer);
    });
  });

  function renderCart(cart) {
    const counts = document.querySelectorAll('[data-cart-count]');
    counts.forEach(function (c) {
      c.textContent = cart.item_count;
      c.hidden = cart.item_count === 0;
    });

    if (!drawer) return;
    const itemsEl = drawer.querySelector('[data-cart-items]');
    const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    const footerEl = drawer.querySelector('[data-cart-footer]');

    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p></div>';
      if (footerEl) footerEl.hidden = true;
      return;
    }
    if (footerEl) footerEl.hidden = false;

    itemsEl.innerHTML = cart.items.map(function (item) {
      const img = item.image ? '<img src="' + item.image + '" alt="' + item.title + '" width="64" height="64">' : '<div class="cart-item__img"></div>';
      return '<div class="cart-item" data-line-key="' + item.key + '">' +
        img +
        '<div><div class="cart-item__title">' + item.product_title + '</div>' +
        '<div class="text-muted" style="font-size:0.85rem">' + (item.variant_title || '') + '</div>' +
        '<div class="qty" style="margin-top:0.5rem">' +
          '<button type="button" data-line-minus aria-label="Decrease">&minus;</button>' +
          '<input type="text" value="' + item.quantity + '" readonly aria-label="Quantity">' +
          '<button type="button" data-line-plus aria-label="Increase">+</button>' +
        '</div></div>' +
        '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
      '</div>';
    }).join('');

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    itemsEl.querySelectorAll('.cart-item').forEach(function (row) {
      const key = row.getAttribute('data-line-key');
      const input = row.querySelector('input');
      row.querySelector('[data-line-plus]').addEventListener('click', function () {
        changeLine(key, parseInt(input.value, 10) + 1);
      });
      row.querySelector('[data-line-minus]').addEventListener('click', function () {
        changeLine(key, parseInt(input.value, 10) - 1);
      });
    });
  }

  function refreshCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  /* ---------------- Add to cart ---------------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart]');
      const original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10)
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            if (btn) { btn.textContent = data.description || 'Unavailable'; }
            return;
          }
          return refreshCart().then(openDrawer);
        })
        .finally(function () {
          if (btn) { setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 600); }
        });
    });
  });

  /* ---------------- Quantity stepper (product page) ---------------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    const input = wrap.querySelector('input');
    wrap.querySelector('[data-qty-plus]').addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
    });
    wrap.querySelector('[data-qty-minus]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
    });
  });

  /* ---------------- Variant selection ---------------- */
  document.querySelectorAll('[data-variant-selector]').forEach(function (root) {
    const variants = JSON.parse(root.querySelector('[data-variants-json]').textContent);
    const idInput = root.querySelector('[name="id"]');
    const priceEl = root.querySelector('[data-product-price]');
    const addBtn = root.querySelector('[data-add-to-cart]');

    function update() {
      const selected = Array.from(root.querySelectorAll('[data-option]:checked')).map(function (i) { return i.value; });
      const match = variants.find(function (v) {
        return v.options.every(function (opt, idx) { return opt === selected[idx]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.getAttribute('data-default-text') : 'Sold out';
      }
    }
    root.querySelectorAll('[data-option]').forEach(function (i) { i.addEventListener('change', update); });
    update();
  });

  /* ---------------- Product gallery thumbs ---------------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-full');
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------------- Newsletter status from URL ---------------- */
  const params = new URLSearchParams(window.location.search);
  if (params.get('contact_posted') === 'true' || params.get('customer_posted') === 'true') {
    document.querySelectorAll('[data-signup-success]').forEach(function (el) { el.hidden = false; });
  }

  /* ---------------- Scroll reveal ---------------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------------- Animated counters ---------------- */
  function animateCount(el) {
    var raw = el.getAttribute('data-count');
    var match = raw.match(/^([0-9]+)(.*)$/);
    if (!match) { el.textContent = raw; return; }
    var target = parseInt(match[1], 10);
    var suffix = match[2] || '';
    var start = null;
    var duration = 1400;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.floor(eased * target) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target + suffix;
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll('[data-count]');
  if ('IntersectionObserver' in window && counters.length) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { animateCount(entry.target); cio.unobserve(entry.target); }
      });
    }, { threshold: 0.5 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* ---------------- Sticky buy bar ---------------- */
  var buyBar = document.querySelector('[data-buy-bar]');
  if (buyBar) {
    var anchor = document.querySelector('[data-product-form]');
    var pageFooter = document.querySelector('.site-footer');
    function toggleBar() {
      var show = true;
      if (anchor) {
        var rect = anchor.getBoundingClientRect();
        show = rect.bottom < 0 || rect.top > window.innerHeight;
      } else {
        show = window.scrollY > window.innerHeight * 0.8;
      }
      // Hide the sticky bar once the footer scrolls into view so it never overlaps it.
      if (show && pageFooter && pageFooter.getBoundingClientRect().top < window.innerHeight) {
        show = false;
      }
      buyBar.setAttribute('data-visible', String(show));
    }
    window.addEventListener('scroll', toggleBar, { passive: true });
    window.addEventListener('resize', toggleBar);
    toggleBar();
    var barBtn = buyBar.querySelector('[data-buy-bar-add]');
    if (barBtn && anchor) {
      barBtn.addEventListener('click', function () {
        var id = anchor.querySelector('[name="id"]');
        if (!id) return;
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id.value, quantity: 1 })
        }).then(function () { return refreshCart(); }).then(openDrawer);
      });
    }
  }

  if (window.Shopify) refreshCart();
})();
